/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * プレスリリースの配信ステータス・配信時間を取得するAPIのレスポンスデータ
 * @export
 * @interface GetReleaseStatusResponse
 */
export interface GetReleaseStatusResponse {
    /**
     * 配信ステータス
     * @type {number}
     * @memberof GetReleaseStatusResponse
     */
    status: GetReleaseStatusResponseStatusEnum;
    /**
     * 配信日時
     * @type {string}
     * @memberof GetReleaseStatusResponse
     */
    releaseDate: string | null;
}

/**
* @export
* @enum {string}
*/
export enum GetReleaseStatusResponseStatusEnum {
    DRAFT = 0,
    RESERVED = 1,
    COMPLETED = 2
}

export function GetReleaseStatusResponseFromJSON(json: any): GetReleaseStatusResponse {
    return GetReleaseStatusResponseFromJSONTyped(json, false);
}

export function GetReleaseStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReleaseStatusResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'releaseDate': json['release_date'],
    };
}

export function GetReleaseStatusResponseToJSON(value?: GetReleaseStatusResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'release_date': value.releaseDate,
    };
}

